const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires='${date.toString()}'`;
    } else {
        expires = '';
    }
    document.cookie = `${name}=${value + expires}; path=/`;
};

const getCookie = (name) => {
    if (document.cookie.length > 0) {
        let start = document.cookie.indexOf(`${name}=`);

        if (start !== -1) {
            start = start + name.length + 1;

            let end = document.cookie.indexOf(';', start);

            if (end === -1) end = document.cookie.length;

            return unescape(document.cookie.substring(start, end));
        }
    }

    return false;
};

export { setCookie, getCookie };
